import React, { Component } from 'react';
import About from './About';
import Location from './Location';
import SliderPhoto from './SliderPhoto';
import Gallery from './Gallery';
import { connect } from 'react-redux';
import { Row, Col, PageHeader } from 'antd';
import { cityByProvince } from '../../../redux/actions/master/cities/citiesAction';
import { provinceByCountry } from '../../../redux/actions/master/provinces/provincesAction';
import { masterCountries, unmountMasterCountries } from '../../../redux/actions/master/countries/countriesAction';
import { masterJobIndustries, unmountMasterJobIndustries } from '../../../redux/actions/master/jobIndustries/jobIndustriesAction';
import { getAbout, getLocation, sliderPhoto, getGallery, unmountAbout, unmountLocation, unmountSliderPhoto, unmountGallery, updateAbout, updateLocation, updateSliderPhoto, updateGallery } from '../../../redux/actions/companyProfile/companyProfileAction';

class CompanyProfileEmployer extends Component {
  render() {
    return (
      <React.Fragment>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <PageHeader className="site-page-header" title="Company Profile" />
          </Col>
          <Col span={24}>
            <SliderPhoto {...this.props} />
          </Col>
          <Col span={24}>
            <About {...this.props} />
          </Col>
          <Col span={24}>
            <Location {...this.props} />
          </Col>
          <Col span={24}>
            <Gallery {...this.props} />
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  componentWillUnmount() {
    const { unmountGetSliderPhoto, unmountGetAbout, unmountGetLocation, unmountGetGallery, unmountGetJobIndustry, unmountGetCountry } = this.props;
    unmountGetSliderPhoto()
    unmountGetAbout()
    unmountGetLocation()
    unmountGetGallery()
    unmountGetJobIndustry()
    unmountGetCountry()
  }
}

const mapStateToProps = (state) => ({
  getSliderPhoto    : state.companyProfile.sliderPhoto,
  getDetailAbout    : state.companyProfile.about,
  getDetailLocation : state.companyProfile.location,   
  getGallery        : state.companyProfile.gallery,   
  getJobIndustry    : state.jobIndustries.master,
  getCountry        : state.countries.master
})

const mapDispatchToProps = {
  actionUpdateSlider    : updateSliderPhoto,
  actionUpdateAbout     : updateAbout,
  actionUpdateLocation  : updateLocation,
  actionUpdateGallery   : updateGallery,
  actionGetSliderPhoto  : sliderPhoto,
  actionGetAbout        : getAbout,
  actionGetLocation     : getLocation,
  actionGetGallery      : getGallery,
  actionGetJobIndustry  : masterJobIndustries,
  actionGetCountry      : masterCountries,
  actionGetProvince     : provinceByCountry,
  actionGetCity         : cityByProvince,
  unmountGetSliderPhoto : unmountSliderPhoto,
  unmountGetAbout       : unmountAbout,
  unmountGetLocation    : unmountLocation,
  unmountGetGallery     : unmountGallery,
  unmountGetJobIndustry : unmountMasterJobIndustries,
  unmountGetCountry     : unmountMasterCountries,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyProfileEmployer)
